import request from '../api/request'
import {base64urlToUint8Array, uint8ArrayToBase64url} from "@/utils/base64urlToUint8";
import showToast from "@/utils/toast";

export default {
    namespaced: true,
    state: {
        isLogin: false,
        username: "访客",
        nickname: "访客",
        email: "",
        userImage: "",
        token: "",
        roleId: null,
    },
    mutations: {
        login(state, value) {
            state.username = value.username
            state.nickname = value.nickname
            state.email = value.email
            state.userImage = value.userImage
            state.token = value.token
            state.roleId = value.roleId
            state.isLogin = true
        },
        logout(state) {
            state.username = '访客'
            state.nickname = '访客'
            state.email = ''
            state.userImage = ''
            state.token = ''
            state.roleId = null;
            state.isLogin = false
        }
    },
    actions: {
        async login({commit}, loginForm) {
            try {
                const response = await request.post('/v1/api/login', {
                    username: loginForm.account,
                    pd: loginForm.password
                })
                const rsp = response.data;
                if (rsp.responseCode === '0000') {
                    const userInfo = rsp.data;
                    //本地存储
                    sessionStorage.setItem('laputa-token', userInfo.token)
                    commit('login', userInfo);
                    return {userInfo}
                } else {
                    throw new Error(rsp.responseDesc)
                }
            } catch (error) {
                throw new Error(error.message)
            }
        },
        async loginPasskey({commit}, loginForm) {
            try {
                const response = await request.get(`/v1/api/loginStart`)
                const rsp = response.data;

                if (rsp.responseCode === '0000') {
                    const data = rsp.data;
                    const {redisKey, requestOpts} = data;
                    const publicKey = requestOpts;
                    publicKey.challenge = base64urlToUint8Array(publicKey.challenge);
                    // allowCredentials 里面每一个credential id都要转Uint8Array
                    publicKey.extensions = {}
                    if(publicKey.allowCredentials){
                        publicKey.allowCredentials = publicKey.allowCredentials.map(item=>{
                            return {
                                ...item,
                                id: base64urlToUint8Array(item.id)
                            }
                        })
                    }else {
                        publicKey.allowCredentials = []
                    }
                    try {
                        const credential = await navigator.credentials.get({publicKey});
                        const assertionResponse = credential.response;
                        const submitPayload = {
                            redisKey,
                            publicKeyCredential: JSON.stringify({
                                id: credential.id,
                                rawId: uint8ArrayToBase64url(credential.rawId),
                                type: credential.type,
                                response: {
                                    authenticatorData: uint8ArrayToBase64url(assertionResponse.authenticatorData),
                                    clientDataJSON: uint8ArrayToBase64url(assertionResponse.clientDataJSON),
                                    signature: uint8ArrayToBase64url(assertionResponse.signature),
                                    userHandle: assertionResponse.userHandle ? uint8ArrayToBase64url(assertionResponse.userHandle) : null
                                },
                                clientExtensionResults: credential.getClientExtensionResults()
                            })
                        };

                        // 提交后端做Assertion验签
                        try {
                            const finishResponse = await request.post("/v1/api/loginFinish", submitPayload);
                            const finishResp = finishResponse.data;
                            if (finishResp.responseCode === '0000') {
                                const userInfo = finishResp.data;
                                //本地存储
                                sessionStorage.setItem('laputa-token', userInfo.token)
                                commit('login', userInfo);
                                return {userInfo}
                            }else {
                                throw new Error(finishResp.responseDesc)
                            }
                        } catch (e) {
                            throw new Error(e.message)
                        }
                    } catch(err){
                        throw new Error(err.message)
                    }
                } else {
                    throw new Error(rsp.responseDesc)
                }
            } catch (error) {
                throw new Error(error.message)
            }
        },
        async register({commit}, registerForm) {
            try {
                const response = await request.post('/v1/api/register', {
                    username: registerForm.username,
                    pd: registerForm.password,
                    code: registerForm.code
                })
                const rsp = response.data;
                if (rsp.responseCode === '0000') {
                    const userInfo = rsp.data;
                    //本地存储
                    sessionStorage.setItem('laputa-token', userInfo.token)
                    commit('login', userInfo);
                    return {userInfo}
                } else {
                    throw new Error(rsp.responseDesc)
                }
            } catch (error) {
                throw new Error(error.message)
            }
        },
        async refresh({commit}) {
            const hasToken = sessionStorage.getItem('laputa-token')
            if (!hasToken) return
            try {
                const response = await request.post('/v1/api/refresh')
                const rsp = response.data;
                if (rsp.responseCode === '0000') {
                    const userInfo = rsp.data;
                    //本地存储
                    sessionStorage.setItem('laputa-token', userInfo.token)
                    commit('login', userInfo);
                } else {
                    commit('logout');
                    sessionStorage.removeItem('laputa-token')
                    throw new Error(rsp.responseDesc)
                }
            } catch (e) {
                commit('logout');
                sessionStorage.removeItem('laputa-token')
                if (e.response) {
                    if (e.response.status === 401) {
                        throw new Error('登录已失效，请重新登录')
                    } else {
                        throw new Error(e.response.message)
                    }
                } else {
                    throw new Error('网络异常')
                }
            }
        },
        async logout({state,commit}) {
            try {
                const response = await request.post('/v1/api/logout', {
                    username:state.email
                })
                const rsp = response.data;
                if (rsp.responseCode === '0000') {
                    //本地存储
                    sessionStorage.removeItem('laputa-token')
                    commit('logout');
                } else {
                    throw new Error(rsp.responseDesc)
                }
            } catch (e) {
                if (e.response) {
                    throw new Error(e.response.message)
                } else {
                    throw new Error('网络异常')
                }
            }
        }
    }
}